<template>
  <div class="flex flex-row justify-start">
    <pbc-tab-button v-model='isPlacement'
                    @click='onClickPlacement'
                    class="p-2 my-2">
      <span class="mx-auto">Place</span>
    </pbc-tab-button>
    <pbc-tab-button v-model='isAnimate'
                    @click='onClickAnimate'
                    :disabled='noTransformsAdded'
                    class="p-2 my-2">
      <span class="mx-auto">Post</span>
    </pbc-tab-button>

    <div class="grow flex flex-row justify-end">
      <button class="transparent-button flex flex-row" @click='showHelp = true'>
        <comment-quote :size='32' />
        <span class="text-xs ml-2">Feedback</span>
      </button>
    </div>

    <portal v-if='showHelp' to="last-modal">
      <pbc-overlay @close='showHelp = false' @done='showHelp = false'>
        <div class="bg-gray-300 p-1 grow overflow-hidden flex flex-col">
          <pbc-cta-help class="overflow-y-auto grow" />
        </div>
      </pbc-overlay>
    </portal>
    
  </div>

</template>
<script>
import PbcCtaHelp from '@ui/atoms/PbcCtaHelp.vue';
import CommentQuote from '@icons/CommentQuote.vue';
import { mapState } from 'vuex';
import PbcTabButton from '@ui/atoms/PbcTabButton.vue';
export default {
  props:{
    current:{
      type: String,
      required: true
    },
    enableAnimate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showHelp: false
    }
  },
  components:{
    PbcTabButton,
    CommentQuote,
    PbcCtaHelp
  },
  methods: {
    onClickPost() {
      this.$emit('mode', 'post');
    },
    onClickAnimate() {
      this.$emit('mode', 'animate');
    },
    onClickPlacement() {
      this.$emit('mode', 'placement');
    }
  },
  computed:{
    mode:{
      get() {
        return this.current;
      },
      set(nv) {
        this.$emit('change-mode', nv);
      }
    },
    isPlacement: {
      set(nv) {
        this.mode = "placement"
      },
      get() {
        return this.mode === 'placement';
      }
    },
    isAnimate: {
      set(nv) {
        this.mode = "animate"
      },
      get() {
        return this.mode === 'animate' || this.mode === "post";
      }
    },
    isPost: {
      set(nv) {
        this.mode = "post"
      },
      get() {
        return this.mode === 'post';
      }
    },
    ...mapState(['noTransformsAdded'])
  }
}
</script>

